var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "badge",
    {
      directives: [
        {
          name: "b-tooltip",
          rawName: "v-b-tooltip.bottom",
          value: _vm.$t("direct-to-lender.lenderSubmit.applicationStatus"),
          expression: "$t('direct-to-lender.lenderSubmit.applicationStatus')",
          modifiers: { bottom: true },
        },
      ],
      staticClass: "m-0 badge-notification",
      attrs: { type: _vm.badgeType },
    },
    [_vm._v("\n  " + _vm._s(_vm.getStatusLabel(_vm.applicationStatus)) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }